"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getReadOnly;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _getChildren = _interopRequireDefault(require("@sift/runner/getChildren"));

var _isField = _interopRequireDefault(require("@sift/runner/isField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEditable(node, config) {
  var children = (0, _getChildren.default)(node, config);

  if ((0, _isField.default)(node)) {
    return !(0, _get2.default)(node, ['valueReadOnly'], false);
  }

  var childrenEditable = children.some(function (child) {
    return getEditable(child, config);
  });
  return childrenEditable;
}

function getReadOnly(node, config) {
  return !getEditable(node, config);
}